export default __webpack_public_path__ + "static/img_4-09e95016cd01b9e83ca7a2caa13d5f72.png";